import * as fabric from 'office-ui-fabric-react';
import { ChangeEvent, FC, useState } from 'react';
import { toast } from 'react-toastify';

interface IProps {
    label: string;
    inputKey: number;
    setImagePreview: (result: string) => void;
    onChange: (response: File | null) => Promise<void>;
    imagePreview: string | null;
}

const ImageInput: FC<IProps> = (props) => {
    const [isFileInputHidden, setIsFileInputHidden] = useState<boolean>(props.imagePreview !== null);

    const readFile = (file: File): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            const reader: FileReader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = async (e: any) => {
                props.setImagePreview(e.target.result);
                setIsFileInputHidden(true);
                resolve(true);
            };
            reader.onerror = () => {
                reader.abort();
                reject(false);
            };
        });
    };

    const handleChange = async (e: ChangeEvent<HTMLInputElement> | null) => {
        if (e && e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const isFileRead = await readFile(file);

            if (isFileRead) {
                try {
                    await props.onChange(file);
                    toast.success('Paveikslėlis išsaugotas');
                } catch (ex) {
                    toast.error(ex.error[0]);
                }
            }
        } else {
            try {
                await props.onChange(null);
                toast.success('Paveikslėlis ištrintas');
                setIsFileInputHidden(false);
            } catch (ex) {
                toast.error(ex.error[0]);
            }
        }
    };
    return (
        <div>
            <fabric.Label>{props.label}</fabric.Label>
            {!isFileInputHidden && (
                <div style={{ marginTop: '20px' }}>
                    <input
                        id={props.inputKey.toString()}
                        style={{ display: 'none' }}
                        key="component"
                        type="file"
                        accept="image/*"
                        onChange={handleChange}
                    />
                    <fabric.Stack>
                        <fabric.Stack.Item align="center">
                            <fabric.PrimaryButton
                                onClick={() => {
                                    let element = document.getElementById(props.inputKey.toString());
                                    if (element) element.click();
                                }}
                                text="Pasirinkite failą"
                                iconProps={{ iconName: 'Upload' }}
                            />
                        </fabric.Stack.Item>
                    </fabric.Stack>
                </div>
            )}
            {isFileInputHidden && (
                <>
                    <fabric.Stack>
                        <fabric.Stack.Item align="end">
                            <fabric.IconButton onClick={async () => await handleChange(null)} iconProps={{ iconName: 'ChromeClose' }} />
                        </fabric.Stack.Item>
                    </fabric.Stack>
                    {props.imagePreview && (
                        <div className="ms-depth-16" style={{ marginBottom: '20px' }}>
                            <fabric.Stack>
                                <img style={{ maxHeight: '200px' }} src={props.imagePreview} />
                            </fabric.Stack>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ImageInput;
